import React, { useState } from 'react';
interface CsvRow {
  [key: string]: string;
}
export const TestCsvUpload: React.FC = () => {
  const [data, setData] = useState<CsvRow[]>([]);
  const [headers, setHeaders] = useState<string[]>([]);
  const [error, setError] = useState<string>('');
  const parseCsv = (text: string): {
    headers: string[];
    rows: CsvRow[];
  } => {
    const lines = text.split('\n').filter(line => line.trim());
    if (lines.length === 0) {
      throw new Error('CSV file is empty');
    }
    const headers = lines[0].split(',').map(h => h.trim());
    const rows = lines.slice(1).map(line => {
      const values = line.split(',').map(v => v.trim());
      const row: CsvRow = {};
      headers.forEach((header, index) => {
        row[header] = values[index] || '';
      });
      return row;
    });
    return {
      headers,
      rows
    };
  };
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!file.name.endsWith('.csv')) {
      setError('Please upload a CSV file');
      return;
    }
    const reader = new FileReader();
    reader.onload = e => {
      try {
        const text = e.target?.result as string;
        const {
          headers,
          rows
        } = parseCsv(text);
        setHeaders(headers);
        setData(rows);
        setError('');
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to parse CSV');
      }
    };
    reader.readAsText(file);
  };
  return <div className="p-6 max-w-4xl mx-auto" data-id="element-2619">
      <h2 className="text-2xl font-bold mb-4" data-id="element-2620">CSV Upload Test</h2>

      <div className="mb-6" data-id="element-2621">
        <input type="file" accept=".csv" onChange={handleFileUpload} className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" data-id="element-2622" />
      </div>

      {error && <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-md text-red-700" data-id="element-2623">
          {error}
        </div>}

      {data.length > 0 && <div className="overflow-x-auto" data-id="element-2624">
          <table className="min-w-full border border-gray-200" data-id="element-2625">
            <thead className="bg-gray-50" data-id="element-2626">
              <tr data-id="element-2627">
                {headers.map((header, index) => <th key={index} className="px-4 py-2 text-left text-sm font-semibold text-gray-700 border-b" data-id="element-2628">
                    {header}
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-2629">
              {data.map((row, rowIndex) => <tr key={rowIndex} className="border-b hover:bg-gray-50" data-id="element-2630">
                  {headers.map((header, colIndex) => <td key={colIndex} className="px-4 py-2 text-sm text-gray-600" data-id="element-2631">
                      {row[header]}
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>}
    </div>;
};